import React, { Component } from "react";
import { DataService } from "../services/data.service";
import { Empty } from "antd";

import Loader from "../components/loader/loader";
import * as handler from "../components/utils/handler";

const queryString = require("query-string");
class CategorySelection extends Component {
  defaultLanguage = window["app-config"].defaultLang;
  UI = window["app-config"].ui.categorySelectionScreen;
  collections = window["app-config"].collections;
  estimatedWaitTime =
    window["app-config"].applicationProperties.estimatedWaitTime;

  dataService = new DataService();
  state = {
    lang: {},
    categories: [],
    estimatedWaitTime: null,
    dataLoaded: false,
    isRtl: false,
  };

  async componentDidMount() {
    this.setState({ lang: handler.setTranslations() });
    this.getCategories();
    if (
      this.estimatedWaitTime.branchLevel &&
      this.props.mainState().issueTicket &&
      this.UI.showEstimatedWaitTime
    ) {
      this.getEstimatedWaitTime(
        this.props.branchDetails()[0] !== null
          ? this.props.branchDetails()[0].BranchID
          : null,

        null
      );
    }

    this.props.hideBtnNext();
  }

  sendDataToParent = (categoryId) => {
    this.props.categoryDetails({ categoryId: categoryId });
  };

  setLanguage = () => {
    const language = queryString.parse(window.location.search).lang;

    if (language === "es" || language === "sp") {
      this.setState({
        lang: window["localization"].es,
      });
    } else if (language === "ar") {
      this.setState({
        lang: window["localization"].ar,
      });
    } else if (language === "en") {
      this.setState({
        lang: window["localization"].en,
      });
    } else if (language === "ur") {
      this.setState({
        lang: window["localization"].ur,
      });
    } else {
      let defaultLang = this.defaultLanguage;
      this.setState({
        lang: window["localization"][defaultLang],
      });
    }
  };

  getCategories = async () => {
    try {
      let branchId = this.props.branchDetails()[0].BranchID;
      let response = await this.dataService.getCategoriesByBranchId(branchId);

      let filteredCategories = handler.compareArrayOfObject(
        response.data.categoryList,
        this.collections.categories
      );

      if (response.data.error !== undefined && response.error === true) {
        this.setState({
          categories: undefined,
          dataLoaded: true,
        });
      } else {
        this.setState({
          categories:
            filteredCategories.length > 0
              ? filteredCategories
              : response.data.categoryList,
          dataLoaded: true,
        });
      }
    } catch (error) {
      console.log("ERROR IN GET CATEGORIES", error.message);
      if (error.message.includes("timeout")) {
        this.setState({ categories: undefined, dataLoaded: true });
      } else {
        this.setState({ categories: [], dataLoaded: true });
      }
    }
  };

  getEstimatedWaitTime = async (branchId, sqn) => {
    try {
      let response = await this.dataService.getEstimatedWaitTime(branchId, sqn);

      console.log(response);

      if (response.data.error !== undefined && response.error === true) {
        this.setState({
          estimatedWaitTime: null,
          dataLoaded: true,
        });
      } else if (response.data.response_status === 1) {
        this.setState({
          estimatedWaitTime: Math.floor(response.data.est_wait_time / 60),
          dataLoaded: true,
        });
      } else {
        this.setState({
          estimatedWaitTime: null,
          dataLoaded: true,
        });
      }
    } catch (error) {
      this.setState({
        estimatedWaitTime: null,
        dataLoaded: true,
      });
      console.log("ERROR: ", error.message);
    }
  };

  onCategoryChange = (e) => {
    this.sendDataToParent(e.target.value);

    if (
      this.props.mainState().issueTicket &&
      this.UI.showEstimatedWaitTime &&
      !this.estimatedWaitTime.branchLevel
    ) {
      this.getEstimatedWaitTime(
        this.props.branchDetails()[0].BranchID,
        e.target.value
      );
    }
  };

  render() {
    if (this.state.dataLoaded === false) {
      return <Loader />;
    } else if (
      this.state.categories === undefined &&
      this.state.dataLoaded === true
    ) {
      return (
        <div className="sl__modal--content">
          <div className="sl__modal--row">
            <Empty description={this.state.lang.ServerNotResponding} />
          </div>
        </div>
      );
    } else {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <div className="sl__modal--row">
              <div className="sl__modal_form-row">
                <div className="sl__modal_form-col">
                  <label
                    className="sl__modal_form--label categorylbl"
                    style={{
                      color: this.UI.headingColor,
                    }}
                  >
                    {this.state.lang.WhatDoYouNeed}
                  </label>
                  <select
                    id="category-selector"
                    className="sl__modal_form--select"
                    defaultValue={-1}
                    onChange={this.onCategoryChange}
                    style={{ direction: this.state.isRtl ? "rtl" : "ltr" }}
                  >
                    <option
                      value={-1}
                      disabled
                      style={{ direction: this.state.isRtl ? "rtl" : "ltr" }}
                    >
                      {this.state.lang.SelectCategory}
                    </option>
                    {this.state.categories.length > 0
                      ? this.state.categories.map((data, i) => {
                          return (
                            <option
                              key={i}
                              value={data.CategoryID}
                              style={{
                                direction: this.state.isRtl ? "rtl" : "ltr",
                              }}
                            >
                              {data.CategoryTitle}
                            </option>
                          );
                        })
                      : null}
                  </select>
                  <br /> <br />
                  <br />
                  {this.state.estimatedWaitTime !== null &&
                  this.UI.showEstimatedWaitTime ? (
                    <p>
                      {this.state.lang.EstimatedWaitTimeMessage} &nbsp;
                      <strong>{`${this.state.estimatedWaitTime} ${this.state.lang.Minutes}`}</strong>
                    </p>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default CategorySelection;
